export default __webpack_public_path__ + "static/media/jvzoo_logo.2a9abbf8.png";